<div class="stars" [ngClass]="(state$ | async) || 'state-0'">
  <mat-icon class="star star-1">ai</mat-icon>
  <mat-icon class="star star-2">ai</mat-icon>
  <mat-icon class="star star-3">ai</mat-icon>
</div>
